import { render, staticRenderFns } from "./wideBundleDrop.vue?vue&type=template&id=78ce8899&scoped=true"
import script from "./wideBundleDrop.vue?vue&type=script&lang=js"
export * from "./wideBundleDrop.vue?vue&type=script&lang=js"
import style0 from "./wideBundleDrop.vue?vue&type=style&index=0&id=78ce8899&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce8899",
  null
  
)

export default component.exports